export default __webpack_public_path__ + "4605727fac6d71394d7fad8d2ace91e6.svg";